import { HttpEvent, HttpHandler } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GraphqlInterceptorInterceptor,
  SKIP_ERROR_HANDLING_OPERATIONS_LIST,
} from '@tiltgroup/web-components';

/**
 * The library's GraphQL error toast, which also honours the skip list for multipart
 * requests (file uploads): their body is FormData, whose operation name the library
 * can't see, so it would report errors that the page already shows.
 */
@Injectable()
export class GraphqlErrorsInterceptor extends GraphqlInterceptorInterceptor {
  private readonly _skipped: string[] =
    inject(SKIP_ERROR_HANDLING_OPERATIONS_LIST, { optional: true }) ?? [];

  override intercept(
    request: Parameters<GraphqlInterceptorInterceptor['intercept']>[0],
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const name = multipartOperationName(request.body);
    if (name && this._skipped.includes(name)) {
      return next.handle(request);
    }

    return super.intercept(request, next);
  }
}

/** The operation name of a multipart GraphQL request, from its `operations` part. */
export function multipartOperationName(body: unknown): string | null {
  if (!(body instanceof FormData)) {
    return null;
  }

  const operations = body.get('operations');
  if (typeof operations !== 'string') {
    return null;
  }

  try {
    const name = (JSON.parse(operations) as { operationName?: unknown })
      .operationName;
    return typeof name === 'string' ? name : null;
  } catch {
    return null;
  }
}
